import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select"; 
import {  isEmptyChk} from 'utils/common'; 


const customStyles = {
    multiValueRemove: (base, state) =>
      state.data.isDisabled
        ? { ...base, display: "none" }
        : { ...base  }
}
const processedOptions =(options)=>{
    ///if no label exists, thn take text
    // let returnArr = [...options]
    // returnArr=  returnArr.map(obj=> ({ ...obj, label: obj.label || obj.text }));
    // return returnArr
    return options
}


const MySelect = props => {
    const {isIDArray = true} = props;
    
    function processInputvalue(valueArr) {
        if (isIDArray) {
            return props.options.filter((item) => valueArr.indexOf(item.value) != -1);
        }
        return props.options.filter((opt) => valueArr.find(item => item.value === opt.value));
    }

    function onChange(values){ 
        if (isIDArray) {
            props.onChange({ target: { name: props.name, value: values ? values.map(val=> {return val.value}) : [] } })
        } else {
            props.onChange({ target: { name: props.name, value: values ? values : [] } })
        }
    } 

    if (props.allowSelectAll) {
        return (
        <ReactSelect
            {...props} styles={customStyles}
            className="basic-multi-select"
            classNamePrefix="select"
            value={processInputvalue(props.value)}
            options={[props.allOption, ...processedOptions(props.options)]}
            onChange={selected => {
                if (selected !== null &&
                    selected.length > 0 &&
                    selected[selected.length - 1].value === props.allOption.value
                ) {
                    return onChange(props.options);
                }
                ///persist fixed items if try to clear all or try to delete fixed item by pressing backspace
                if(!isEmptyChk(selected))selected = [...props.options.filter(item=>item.isDisabled), ...selected.filter(item=>!item.isDisabled)]
                else selected = [...props.options.filter(item=>item.isDisabled)]
                // selected = [...props.options.filter(item=>item.isDisabled), !isEmptyChk(selected)?[...selected.filter(item=>!item.isDisabled)]:[]]
                
                // if(!selected ||selected && selected.length==0) selected = props.options.filter(item=>item.isDisabled)
                return onChange(selected);
            }}
        />
        );
    }

  return <ReactSelect 
            {...props} 
            className="basic-multi-select"
            value={processInputvalue(props.value)} 
            onChange={selected => {return onChange(selected)}}
        />;
};

MySelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

MySelect.defaultProps = {
    allOption: {
        label: "Select all",
        value: "*"
    }, 
    isMulti:true,
    closeMenuOnSelect:false,
    hideSelectedOptions:false, 
    allowSelectAll:true,
    isClearable:true
    // value:this.state.optionSelected
};

export default MySelect;
